// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonIcon } from "@insite/mobius/Button";
import { getProp } from "@insite/mobius/utilities";
import { cartLinkStyles } from "@synd/Overrides/Widgets/Common/CartLink";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

cartLinkStyles.countText = {
    ...fontConfig.xxxSmallSingleLine,
    css: css`
        width: 22px;
        height: 22px;
        border-radius: 4px;
        background-color: ${color("common.ui9")};
        color: ${color("common.white")};
        text-align: center;
        padding: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

cartLinkStyles.xngTooltip = {
    drawerContent: {
        css: css`
            background-color: ${color("common.ui1")};
            display: flex;
            position: fixed;
            flex-direction: column;
            right: 0;
            top: 0;
            height: 100vh;
            width: 467px;
            z-index: ${getProp("theme.zIndex.drawerOverlay")};
            transition: right 0.3s ease-in-out;
            visibility: hidden;
            transform: translateX(483px); // 467px width + 16px margin
            transition:
                transform 0.5s ease-in-out,
                visibility 0s 0.5s;

            ${({ isMounted }: any) =>
                isMounted &&
                css`
                    visibility: visible;
                    transform: translateX(0);
                    transition:
                        transform 0.5s ease-in-out,
                        visibility 0s;
                `}
        `,
    },
    drawerInnerContent: {
        css: css`
            padding: 0;
            &,
            & > div {
                height: 100%;
            }
        `,
    },
    titleWrapper: {
        css: css`
            padding-right: 24px;
        `,
    },
    drawerClose: {
        css: css`
            &&&&&:not(:disabled) {
                &,
                & ${ButtonIcon} {
                    color: ${color("common.ui6")};
                }
            }
            &&&&:not(:disabled):hover ${ButtonIcon} {
                color: ${color("common.ui10")};
            }
        `,
    },
    
};
